import { Button } from 'antd';
import { Flex } from 'antd/lib';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { MailOutlined } from '@ant-design/icons';
import Markdown from 'react-markdown';
import React from 'react';
import { SanitizedHtml } from './SanitizedHtml';

import { COPY_SPECIFIC, EMAILS } from '@sonar-software/sonar-ts-constants';

export interface AiMarkdownContentProps {
	hasError?: boolean;
	hasPromptLengthError?: boolean;
	text: string;
}

export const AiMarkdownContent: React.FC<AiMarkdownContentProps> = ({ hasError, hasPromptLengthError, text }) => {
	if (!hasError && !text) {
		return (
			<LoadingSpinner
				size='large'
				spinning />
		);
	}

	if (hasError || hasPromptLengthError) {
		return (
			<>
				<p>
					<SanitizedHtml
						as='span'
						html={ hasPromptLengthError ?
							COPY_SPECIFIC.AI_PROMPT_LENGTH_ERROR :
							COPY_SPECIFIC.AI_RESPONSE_FAILURE(EMAILS.SUPPORT) } />
				</p>
				<Flex
					align='center'
					vertical>
					<Button
						icon={ <MailOutlined /> }
						type='default'>
						{ COPY_SPECIFIC.CONTACT_SUPPORT }
					</Button>
				</Flex>
			</>
		);
	}

	return <Markdown>{ text }</Markdown>;
};
